<div class="col help-card k-mb-7">
  <i class="ph ph-info"></i>
  {{ message }} <a [routerLink]="link">clic aquí.</a>
</div>
